import service from "./service";

export const findAll = () => {
  return service.get("/v1/config");
};

export const saveConfig = configs => {
  return service.post(`/v1/config`, { configs });
};

export const testEmail = email => {
  return service.post(`/v1/config/test-send-mail`, { email });
};
